// Static content and image URLs used across the site.
export const BRAND = {
  name: "AF Legacy Sports",
  slogan: "WE DON'T MANAGE PLAYERS. WE BUILD LEGACY.",
  short: "Scouting, desenvolvimento de jogadores e gestão de carreira no futebol.",
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_af-legacy-deploy/artifacts/esjwqcqz_AF_LegacySports_Transparente.png",
  email: "info@aflegacysports.com",
  scouting_phone: "+351 913 015 666",
  whatsapp_number: "351913015666",
  address: {
    line1: "Parque Suécia, Edifício I",
    line2: "Piso 1 · Fração 2.01",
    postal: "2790-073 Carnaxide",
    country: "Portugal",
  },
  socials: {
    instagram: "https://www.instagram.com/af_legacysports/",
    linkedin: "https://www.linkedin.com/company/af-legacy/",
    whatsapp: "https://wa.me/351913015666",
  },
};

export const IMAGES = {
  heroTunnel:
    "https://images.unsplash.com/photo-1595320260530-f3b188507214?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  stadiumNight:
    "https://images.unsplash.com/photo-1676746610993-fa0c050d1f6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  athletePortrait:
    "https://images.unsplash.com/photo-1435348773030-a1d74f568bc2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  contractSigning:
    "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  scoutingWork:
    "https://images.unsplash.com/photo-1518604666860-9ed391f76460?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  training:
    "https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  boots:
    "https://images.unsplash.com/photo-1551958219-acbc608c6377?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  locker:
    "https://images.unsplash.com/photo-1543326727-cf6c39e8f84c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV = [
  { label: "Início", to: "/" },
  { label: "Sobre nós", to: "/sobre-nos" },
  { label: "Serviços", to: "/servicos" },
  { label: "Jogadores", to: "/jogadores" },
  { label: "Clubes e parceiros", to: "/clubes-parceiros" },
  { label: "Legacy News", to: "/legacy-news" },
  { label: "Contactos", to: "/contactos" },
];
